import React from 'react';
import MekaHeader from '../pages/MekaHeader';
const headers = [
    { path:"/group",element:<MekaHeader text="Groups List" />},
    { path:"/monitor/edit/:id",element:<MekaHeader text="Monitor Edit" />},
    { path:"/track",element:<MekaHeader text="Tracks List" />},
    { path:"/playlist",element:<MekaHeader text="Playlists List" />},
    { path: "/profile", element: <MekaHeader text="Profile" /> },
    { path: "/user", element: <MekaHeader text="Users List" /> },
    { path: "/user/new", element: <MekaHeader text="User New" /> },
    { path: "/user/edit/:id", element: <MekaHeader text="User Edit" /> },
    { path: "/signon", element: null },
    { path: "/signup", element: null },
    { path: "/", element: <MekaHeader text="Profile" /> }
];
export default headers;
